import {
  ArticleBackground,
  ArticleImg,
  ArticleSubTitle,
  ArticleText,
  ArticleTextItem,
  ArticleTitle,
} from './Article.styled';
import img from '../../assets/blog-img.jpg';

const Article = () => {
  return (
    <ArticleBackground>
      <ArticleTitle>
        Регламент використання безпілотників 2024 - все, що вам потрібно знати
      </ArticleTitle>

      <ArticleImg src={img} alt="Drone" />

      <ul>
        <ArticleTextItem>
          <ArticleSubTitle>
            Заходи безпеки при експлуатації дронів класса S
          </ArticleSubTitle>
          <ArticleText>
            Пояснюємо правила, що застосовуються до безпілотників у Польщі. Ви
            дізнаєтесь про регуляторні нововведення, які були прийняті для
            захисту державних і приватних інтересів та сприяння розвитку
            безпілотників у різних галузях. Ознайомтеся із Законом про
            безпілотники 2024, де ви дізнаєтеся, як країни-члени EASA (включаючи
            Польщу) формують правила, щоб ефективно піклуватися про
            громадськість, забезпечуючи при цьому конфіденційність і
            дотримуючись прав людини.
          </ArticleText>
        </ArticleTextItem>

        <ArticleTextItem>
          <ArticleSubTitle>
            Протягом якого періоду часу застосовуються Регламенти ЄС 2019/947 та
            2019/945?
          </ArticleSubTitle>
          <ArticleText>
            У зв'язку з кризою COVID-19, дата початку подачі заявок на участь у
            конкурсі була перенесена на більш пізній термін регламент ЄС
            2019/947 відкладено з 1 липня 2020 року. в 31 рік грудень 2020., а
            це означає, що станом на 31 грудня 2020 року. реєстрація операторів
            дронів та сертифікованих дронів є обов'язковою станом на 31 грудня
            2020 року. операції в категорії "спеціальні" можуть здійснюватися з
            дозволу національного авіаційного органу станом на 1 січня 2023
            року. як користувач безпілотника, який експлуатує безпілотні
            літальні апарати без ідентифікаційної етикетки класу, ви все ще
            можете працювати з певними обмеженнями відповідно до ст. 22
            Регламенту ЄС 2019/947 станом на січень 2022 року. національні
            дозволи, сертифікати та декларації повинні бути повністю переведені
            на нову систему ЄС станом на 1 січня 2022 року. держави-члени EASA
            повинні обмінюватися інформацією про географічні зони для GEO в
            цифровому форматі, адаптованому між країнами ЄС станом на січень
            2023 року. всі операції у "відкритій" категорії та всі оператори
            безпілотників повинні повністю відповідати Регламенту ЄС 2019/947 та
            Регламенту ЄС 2019/945
          </ArticleText>
        </ArticleTextItem>

        <ArticleTextItem>
          <ArticleSubTitle>Хто такий оператор дрона?</ArticleSubTitle>
          <ArticleText>
            Оператор дрона - це будь-яка фізична або юридична особа, яка володіє
            або наймає дрон(и). Ви можете бути як оператором дрона, так і
            пілотом, якщо ви також є людиною, яка фактично керує дроном. З
            іншого боку, ви можете бути пілотом, не будучи оператором дрона,
            якщо, наприклад, ви пілот, який працює в компанії, що надає послуги
            з використання дронів. У цьому випадку компанія є оператором дрона,
            а ви - пілотом. Якщо ви купили дрон, щоб літати на ньому у вільний
            час, ви одночасно і оператор дрона, і пілот. Якщо ви купили дрон,
            щоб подарувати його, людина, яка отримує подарунок, а потім керує
            дроном, буде оператором і пілотом дрона.
          </ArticleText>
        </ArticleTextItem>

        <ArticleTextItem>
          <ArticleSubTitle>
            До яких типів дронів відноситься регулювання?
          </ArticleSubTitle>
          <ArticleText>
            Регламент поширюється на всі типи літальних апаратів без пілота на
            борту, включаючи радіокеровані літаючі моделі (механічні літаки,
            вертольоти, планери, RPAS), незалежно від того, чи обладнані вони
            камерою. Дрон інакше відомий як безпілотний літальний апарат (БПЛА),
            що означає, що він працює або призначений для роботи автономно або
            дистанційно без пілота на борту. Регламент стосується; повітряні
            роботи міська повітряна мобільність аматорські польоти, в тому числі
            на авіамоделях міжнародні рейси IFR RPAS (Remotely Piloted Aircraft
            Systems) - це підкатегорія БПЛА, яка включає повністю автономні
            дрони, що літають повністю автономно, без необхідності втручання
            пілота.
          </ArticleText>
        </ArticleTextItem>
      </ul>
    </ArticleBackground>
  );
};

export default Article;
